import { render, staticRenderFns } from "./digicon-player.vue?vue&type=template&id=b30bc8e8&scoped=true&"
import script from "./digicon-player.vue?vue&type=script&lang=js&"
export * from "./digicon-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30bc8e8",
  null
  
)

export default component.exports